export enum ActionTypes {
  REQUEST = "@mensagem-categoria/REQUEST",
  SUCCESS = "@mensagem-categoria/SUCCESS",
  FAILURE = "@mensagem-categoria/FAILURE",
  SET = "@mensagem-categoria/SET",
}
